<template>
  <div>
    <div class="d-flex align-items-center colg-forminput">
      <div class="d-flex flex-column" :class="singlerow ? 'w-20' : 'w-40'">
        <label class="mb-0 fs-14 fw-500 font-mont color-344054">
          {{ label }}<span v-if="mandatory" class="color-red">*</span>
        </label>
        <label class="mb-0 fs-13 fw-300 font-mont color-344054 style-italic">
          {{ sublabel }}
        </label>
      </div>

      <b-form-textarea
        :placeholder="placeholder"
        :class="singlerow ? 'w-80class ml-n1' : 'w-60'"
        rows="1"
        max-rows="6"
        :value="value"
        @input="$emit('input', $event)"
        :maxlength="maxChars"
        :disabled="disabled"
      />
    </div>
    <p class="my-0 mr-0 fs-14 font-lato color-667085 ml-190px">
      {{ remainingChars }} characters left
    </p>
  </div>
</template>

<script>
export default {
  props: {
    mandatory: Boolean,
    showError: Boolean,
    label: String,
    sublabel: String,
    placeholder: String,
    singlerow: Boolean,
    value: {
      type: String,
      default: "",
    },
    maxChars: {
      type: Number,
      default: 320,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    remainingChars() {
      return this.maxChars - (this.value?.length || 0);
    },
  },
};
</script>

<style>
.ml-190px {
  margin-left: 190px;
}
.colg-forminput .form-control {
  padding: 10px 14px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #333333;
  width: 60%;
}
.colg-forminput .form-control:focus {
  box-shadow: none;
  color: #333333;
  background-color: #fff;
  outline: 0;
}
.w-80class {
  width: 81% !important;
}
.colg-forminput
.form-control:disabled,.form-control[readonly] {
  background: #f7f7f7;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border: unset;
}
</style>
